/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Frame_Rate_LabelInputs */

const en_embed_captions_frame_rate_label = /** @type {(inputs: Embed_Captions_Frame_Rate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frame Rate`)
};

const fr_embed_captions_frame_rate_label = /** @type {(inputs: Embed_Captions_Frame_Rate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frequence d'images`)
};

const de_embed_captions_frame_rate_label = /** @type {(inputs: Embed_Captions_Frame_Rate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildrate`)
};

const it_embed_captions_frame_rate_label = /** @type {(inputs: Embed_Captions_Frame_Rate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frequenza dei fotogrammi`)
};

const ru_embed_captions_frame_rate_label = /** @type {(inputs: Embed_Captions_Frame_Rate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Частота кадров`)
};

const es_embed_captions_frame_rate_label = /** @type {(inputs: Embed_Captions_Frame_Rate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocidad de fotogramas`)
};

const zh_cn2_embed_captions_frame_rate_label = /** @type {(inputs: Embed_Captions_Frame_Rate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`帧率`)
};

const ja_embed_captions_frame_rate_label = /** @type {(inputs: Embed_Captions_Frame_Rate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フレームレート`)
};

const hi_embed_captions_frame_rate_label = /** @type {(inputs: Embed_Captions_Frame_Rate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ्रेम रेट`)
};

const pt_pt2_embed_captions_frame_rate_label = /** @type {(inputs: Embed_Captions_Frame_Rate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taxa de quadros`)
};

/**
* | output |
* | --- |
* | "Frame Rate" |
*
* @param {Embed_Captions_Frame_Rate_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_frame_rate_label = /** @type {((inputs?: Embed_Captions_Frame_Rate_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Frame_Rate_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_frame_rate_label(inputs)
	if (locale === "de") return de_embed_captions_frame_rate_label(inputs)
	if (locale === "it") return it_embed_captions_frame_rate_label(inputs)
	if (locale === "ru") return ru_embed_captions_frame_rate_label(inputs)
	if (locale === "es") return es_embed_captions_frame_rate_label(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_frame_rate_label(inputs)
	if (locale === "ja") return ja_embed_captions_frame_rate_label(inputs)
	if (locale === "hi") return hi_embed_captions_frame_rate_label(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_frame_rate_label(inputs)
	return en_embed_captions_frame_rate_label(inputs)
});